import React from "react";
import SingleReviewList from "../components/Reviews/SingleReviewList";

function SingleReview() {
  return (
    <div>
      <SingleReviewList />
    </div>
  );
}

export default SingleReview;
